<template>
  <footer class="bg-white border-t border-gray-200 mt-auto">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-center md:text-left">
          <p class="text-sm text-gray-500">
            &copy; {{ new Date().getFullYear() }} Stock Analysis Dashboard. For educational purposes only.
          </p>
          <p class="text-xs text-gray-400 mt-1">
            Not financial advice. Data may be delayed. Always verify before investing.
          </p>
        </div>
        <div class="flex items-center gap-6">
          <a href="#" class="text-sm text-gray-500 hover:text-gray-700">Privacy</a>
          <a href="#" class="text-sm text-gray-500 hover:text-gray-700">Terms</a>
        </div>
      </div>
    </div>
  </footer>
</template>
